/**
 * HsaFsaBadge - HSA/FSA eligibility indicator
 *
 * Displays a green badge indicating that the service is HSA/FSA eligible.
 * Includes a superscript footnote marker linking to the disclaimer below.
 */

export function HsaFsaBadge() {
  return (
    <div className="-mt-4 flex items-center justify-center">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-catch-avocado-400-20 px-3 py-1">
        <svg
          className="h-4 w-4 text-catch-green-dark"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
            clipRule="evenodd"
          />
        </svg>
        <span className="text-sm font-medium text-catch-green-dark">
          HSA/FSA Eligible<sup className="ml-0.5 text-[10px]">1</sup>
        </span>
      </span>
    </div>
  );
}
